import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
import {
  SearchFilters
} from "../../../types/v1_schemas";
import FilterDaysCheckbox from "./FilterDaysCheckbox";
import { toggleDayFilters, toggleItemInFilterList } from "../../../utils/filters/shared";

type HoursInputProps = {
  compact?: boolean;
  options: string[];
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};

function HoursInput({ compact = false, options, filters, setFilters }: HoursInputProps) {
  const { t } = useTranslation();

  const [daysSelected, setDaysSelected] = useState(() => [] as string[]);

  const setHoursFilter = (option:string) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "hours",
      filter_type: "hours",
      filter_value: option,
    });
    setFilters(toggleDayFilters(filters, option));
    setDaysSelected(toggleItemInFilterList(daysSelected, option));
  };

  return (
    <Fieldset
      legend={t("hoursTitle")}
      legendStyle={compact ? "srOnly" : "large"}
    >
      {options.map((option) => (
        <FilterDaysCheckbox
          name={option}
          value={option}
          label={t(`hoursValues${option.toLowerCase()}`)}
          filters={filters}
          onChange={() => setHoursFilter(option)}
          key={option}
        />
      ))}
    </Fieldset>
  );
}

export default HoursInput;
